import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import BranchGateway from '~apis/branch';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetAllRegions(api: BranchGateway): SagaWatcherReturnType {
    yield takeEvery('branch/branchGetAllRegionsAttempt', handleGetAllRegions, api);
}

function* handleGetAllRegions(api: BranchGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    const response = yield* call([api, api.getAllRegions], {
        authToken,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.branchGetAllRegionsFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        const {
            data,
        } = response.data;

        yield put(combinedActions.branchGetAllRegionsSuccess(data));
    }
}
